import { Grid, Typography } from "@material-ui/core";
import TextInput from "shared/components/input/TextInput";

type ConfigurarPrefeituraProps = {
  control: any;
  register: any;
  setValue: any;
};

const ConfigurarPrefeitura = ({ control, register, setValue }: ConfigurarPrefeituraProps) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "1rem" }}>
        <Typography variant="body2" style={{ fontWeight: "bold" }}>
          Acesso ao sistema da prefeitura
          <Typography variant="body2">Informe abaixo os dados de acesso ao sistema da prefeitura</Typography>
        </Typography>
      </Grid>

      <Grid item md={6} sm={6} xs={6}>
        <TextInput
          id="loginPrefeitura"
          key="loginPrefeituraInput"
          name="loginPrefeitura"
          label="Usuário"
          control={control}
          register={register}
          setValue={setValue}
          usarValidacaoParaFormulario
          placeholder="Informe o usuário"
          maxLength={255}
          autoComplete="off"
        />
      </Grid>
      <Grid item md={6} sm={6} xs={6}>
        <TextInput
          id="senhaPrefeitura"
          key="senhaPrefeituraInput"
          name="senhaPrefeitura"
          label="Senha"
          control={control}
          register={register}
          setValue={setValue}
          isPassword
          usarValidacaoParaFormulario
          placeholder="Informe a senha"
          autoComplete="new-password"
        />
      </Grid>
    </Grid>
  );
};

export default ConfigurarPrefeitura;
